<template>
  <v-list>
    <template v-for="(item, index) in items">
      <v-divider v-if="item.divider" :key="index"></v-divider>
      <v-list-item
        v-if="item.visible !== false && !item.divider"
        :key="item.text"
        :to="item.to"
        :disabled="item.disabled"
        :inactive="item.disabled"
      >
        <v-list-item-action>
          <v-badge
            v-if="item.notificacoes || (item.badge && $store.state.rodada.id)"
            bordered
            dot
            color="error"
            :content="item.notificacoes || ''"
            :value="item.notificacoes"
            overlap
          >
            <v-icon>{{ item.icon }}</v-icon>
          </v-badge>

          <v-icon v-else>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
          <v-list-item-subtitle>{{ item.subtext }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
export default {
  name: "menu-cliente",
  props: {
    notificacoes: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      items: [
        { text: "Loja", icon: "mdi-storefront", to: "/", disabled: false },
        {
          text: "Minhas Empresas",
          icon: "store",
          to: "/empresas",
          disabled: false,
        },
        {
          text: "Meus Pedidos",
          icon: "description",
          to: "/pedidos",
          disabled: false,
        },
        {
          text: "Notificações",
          icon: "notifications",
          to: "/notificacoes",
          disabled: false,
          badge: true,
          notificacoes: 0,
        },
        /* {
          text: "Showroom",
          subtext: "Rodada de Negócios",
          icon: "mdi-tshirt-crew",
          to: "/showroom-rodada",
          // disabled: true,
        }, */
        {
          text: "Rodadas de Negócio",
          icon: "mdi-bullseye",
          to: "/rodadas",
          disabled: false,
          badge: true,
        },
        
        // {
        //   text: "Agenda",
        //   subtext: "Rodada de Negócios",
        //   icon: "mdi-rhombus-split",
        //   to: "/agenda",
        //   disabled: false,
        // },
        { divider: true },
        { text: "Ajuda", icon: "help", to: "/ajuda", disabled: true },
      ],
    };
  },
  watch: {
    notificacoes: function(value) {
      const notif = this.items.find((item) => item.text === "Notificações");
      notif.notificacoes = this.notificacoes;
    },
  },
};
</script>

<style lang="scss" scoped></style>
